const WHITESPACE = /\s+/g;

/** The keyword as it goes into a name: trimmed, with every space, tab or newline removed. */
export function cleanKeyword(keyword: string): string {
  return keyword.replace(WHITESPACE, "");
}
